module.exports = __webpack_public_path__ + "img/tx.e9c53c82.png";